import { Component, OnInit, inject } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "mobile-learning-campaign-public-gateway",
  standalone: true,
  template: "",
})
export class MobileLearningCampaignPublicGatewayComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);

  ngOnInit(): void {
    const token = this.resolveToken();
    if (!token) {
      window.location.replace(`${window.location.origin}/#/learning-campaign/public`);
      return;
    }

    const encodedToken = encodeURIComponent(decodeURIComponent(token));
    window.location.replace(`${window.location.origin}/#/learning-campaign/public/${encodedToken}`);
  }

  private resolveToken(): string | null {
    let current: ActivatedRoute | null = this.route;
    while (current) {
      const token = current.snapshot.paramMap.get("token")?.trim();
      if (token) {
        return token;
      }
      current = current.parent;
    }

    const queryToken = this.route.snapshot.queryParamMap.get("token")?.trim();
    return queryToken || null;
  }
}
